import * as React from "react";
import { ReactSVG } from 'react-svg';

const InstagramIcon = (props) => (
 <ReactSVG src="/instagramIcon.svg" />
);

export default InstagramIcon;
